<template>
  <page-option :disable-add="!checkAccess('workspace.create')" overflow-hidden>
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E">mdi-folder</v-icon>
      </v-avatar>
      <div class="pl-2 title-page"> {{ $t('sidebar.workspace.name') }}</div>
    </template>
    <template #toolbar-btns>
      <base-button
        color="primary"
        text
        @click="onOpenSettingDialog"
        v-if="checkAccess('workspace.setting')"
      >
        <v-icon small left>mdi-cog</v-icon>
        Cài đặt
      </base-button>
      <base-button
        type-action="create"
        @click="onCreateItem()"
        v-if="checkAccess('workspace.create')"
      ></base-button>
    </template>
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        :api="api"
        :headers="headers"
        :params="params"
        :defaultParams="default_params"
        use-grid
        use-scroll-load
        use-top
      >
        <template #top-append-right>
          <v-text-field
            v-model="params.search"
            clearable
            width="200px"
            dense
            hide-details
            outlined
            placeholder="Tìm kiếm theo tên"
            prepend-inner-icon="mdi-magnify"
            single-line
          />
        </template>
        <template #grid-item="{ item }">
          <div class="full-width">
            <div class="btn-group justify-between align-center">
              <span class="ml-2">{{ item.name }}</span>
              <v-spacer></v-spacer>
              <v-btn
                icon
                small
                color="error"
                @click.stop="onDeleteItem(item)"
                v-if="checkAccess('workspace.delete', item)"
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </div>
            <v-divider class="mx-1"></v-divider>
          </div>
          <workspace-item :value="item" @click="onGotoDetail(item)">
            <div class="pt-2 overflow-hidden full-width">
              <div class="btn-group">
                <base-button
                  class="text-none"
                  small
                  @click.stop="onUpdateItem(item)"
                  color="#00ED64"
                  v-if="checkAccess('workspace.update', item)"
                >
                  <span>{{ $t('workspace.setting') }}</span>
                </base-button>
                <span class="mx-1"></span>
                <base-button
                  class="text-none"
                  small
                  use-tooltip
                  v-if="current_user_role == 1 || current_user_role == 2"
                >
                  <span>{{ $t('workspace.info') }}</span>
                  <template #tooltip>
                    <span>
                      {{
                        `${item.layers_count || 0} ${$t(
                          'sidebar.layer.name'
                        )}, ${item.maps_count || 0} ${$t(
                          'sidebar.layer-group.name'
                        )}, ${item.datastores_count || 0} ${$t(
                          'sidebar.datastore.name'
                        )}`
                      }}
                    </span>
                  </template>
                </base-button>
              </div>
            </div>
          </workspace-item>
        </template>
        <template v-slot:[`item.updated_at`]="{ item }">
          <span>{{ item.updated_at | dateTime('short') }}</span>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ item.created_at | dateTime('short') }}</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <base-button-group
            class="full-width"
            :items="menus"
            :value="item"
          ></base-button-group>
        </template>
      </base-serve-table>
    </v-sheet>
    <WorkspaceDialog ref="dialog" @reset="onReset" />
    <WorkspaceGlobalSettingDialog ref="settingDialog" />
  </page-option>
</template>

<script>
import FilterSearch from '@layouts/filter-search.vue'
import WorkspaceItem from './workspace-item.vue'
import { API_WORKSPACE } from '@api'
import { ConfirmBuilder } from '@utils'
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
import WorkspaceDialog from './workspace-dialog.vue'
import WorkspaceGlobalSettingDialog from './workspace-global-setting-dialog.vue'
export default {
  mixins: [],
  components: {
    WorkspaceDialog,
    WorkspaceItem,
    WorkspaceGlobalSettingDialog,
  },
  props: {
    option: {
      type: Object,
      default: () => ({
        params: {},
      }),
    },
  },
  data: (vm) => ({
    default_params: {
      with_count: true,
      sort: 'name',
    },
    params: { search: '', inactive: null },
    menus: [
      {
        type: 'update',
        handler: (item) => vm.onUpdateItem(item),
        disabled: (item) => !vm.checkAccess('workspace.update', item),
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => !vm.checkAccess('workspace.delete', item),
      },
    ],
    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
      },
      {
        text: 'Ngày cập nhật',
        align: 'start',
        sortable: true,
        value: 'updated_at',
      },
      {
        trans: 'field.action',
        value: 'action',
        sortable: false,
        width: '150px',
        align: 'center',
      },
    ],
    current_user_role: 0,
  }),
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    api() {
      return API_WORKSPACE
    },
  },
  created() {
    this.getRole()
  },
  mounted() {},
  methods: {
    onOpenSettingDialog() {
      this.$refs.settingDialog.open()
    },
    onGotoDetail(item) {
      if (this.currentUser.hasRole('access:customer')) {
        return
      }
      this.$router.push({
        name: 'workspace.layers',
        params: { id: item.id },
      })
    },
    onResetPassword(item) {
      this.$refs.resetdialog.open(item)
    },
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.username },
          color: 'error',
        })
        .setType('delete')
        .addText(
          `Hành động này sẽ xóa toàn bộ dữ liệu lớp, nhóm lớp bản đồ, trình bày thuộc ${this.$t(
            'sidebar.workspace.name'
          )} này`
        )
        .addMessage('confirm.delete-name')
        .needConfirmText(item.name)
        .setApplyText('Xác nhận')
      if (await confirm.confirm()) {
        const result = await API_WORKSPACE.destroy(item.id, item)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    onCreateItem() {
      this.$refs.dialog.open({}, EDIT_TYPE.CREATE)
    },
    onUpdateItem(item) {
      this.$refs.dialog.open(item, EDIT_TYPE.UPDATE)
    },
    onReset() {
      this.$refs.table.reload()
    },
    getRole() {
      for (var i = 0; i < this.currentUser.roles.length; i++) {
        if (this.currentUser.roles[i].name == 'Quản Trị Hệ Thống') {
          this.current_user_role = 1
          break
        }
        if (this.currentUser.roles[i].name == 'Biên tập') {
          this.current_user_role = 2
          break
        }
        if (
          this.currentUser.roles[i].name ==
          'Phát triển các ứng dụng, phần mềm khác'
        ) {
          this.current_user_role = 3
        }
      }
    },
  },
}
</script>
<style></style>
